import React, { useEffect } from 'react';
import { useSettings, useStore } from '../context/store';
import Posts from './Posts';

const SuggestedPosts = function (props) {
	if (
		null !== props.suggestedResult &&
		props.suggestedResult.records.length
	) {
		return <Posts posts={props.suggestedResult.records} />;
	}

	return '';
};

export default function NoResults() {
	const { state, dispatch } = useStore();

	const settings = useSettings();

	if ('undefined' !== typeof state && !state.posts.length && !state.loading) {
		return (
			<div className="tf-no-results">
				<div className="tf-no-results__text">
					<div
						className="tf-no-results__title"
						dangerouslySetInnerHTML={{
							__html: settings.noResultsTitle,
						}}
					/>
					<div
						className="tf-no-results__body"
						dangerouslySetInnerHTML={{
							__html: settings.noResultsBody,
						}}
					/>
					<div className="tf-no-results__buttons">
						<button
							className="tf-no-results__reset c-btn c-btn--tertiary"
							onClick={() => dispatch({ type: 'resetFilters' })}
						>
							Clear Filters <i className="icon-replay"></i>
						</button>
						<a href="/contact" className="c-btn c-btn--tertiary">
							Contact Us
						</a>
					</div>
				</div>

				<div className="tf-no-results__divider">
					<div className="tf-no-results__divider-inner">
						Based on your filters, we found some other tours you may
						like!
					</div>
				</div>

				<SuggestedPosts suggestedResult={state.suggestedResult} />
			</div>
		);
	}
	return '';
}
